import { action, makeObservable } from 'mobx';
import { Store } from '../../../store/store';
import { StoreNode } from '../../../store';
import { OnboardFormState } from './onboardFormState';
import { RouteContext } from '../../../routes/routeContext';
import { PageState } from '../../../components/mixins/pageState';

export class OnboardPageState
  extends PageState(StoreNode) {

  readonly nodeType = 'OnboardPage';

  constructor(store: Store) {
    super(store);
    makeObservable<this, 'reset'>(this, {
      attached: action,
      detached: action,
      reset: action,
    });
  }

  readonly form = new OnboardFormState(this.store);

  attached(routeContext: RouteContext) {
    this.baseAttached(routeContext);

    const { user: profile } = this.store;
    if (!profile)
      return;

    this.form.username
      .loadValue(profile.username || '');
    this.form.firstName
      .loadValue(profile.firstName || '');
    this.form.lastName
      .loadValue(profile.lastName || '');
    this.form.industry
      .loadValue(profile.industry || '');
    this.form.jobFunction
      .loadValue(profile.jobFunction || '');
    this.form.companySize
      .loadValue(profile.companySize || '');
    this.form.jobTitle
      .loadValue(profile.jobTitle || '');
    this.form.organizationName
      .loadValue(profile.organizationName || '');
    this.form.country
      .loadValue(profile.country || '');
    this.form.state
      .loadValue(profile.state || '');

    this.broadcast('mounted');
  }

  detached() {
    this.baseDetached();
    this.reset();
  }

  private reset() {
    this.baseReset();
    this.form.reset();
  }
}
